import { render, staticRenderFns } from "./Comment_detail.vue?vue&type=template&id=58246a5d&scoped=true&"
import script from "./Comment_detail.vue?vue&type=script&lang=js&"
export * from "./Comment_detail.vue?vue&type=script&lang=js&"
import style0 from "./Comment_detail.vue?vue&type=style&index=0&id=58246a5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58246a5d",
  null
  
)

export default component.exports